/*
 * @Description:日程
 * @Author: 山淑兰
 * @Date: 2020-05-09 18:42:05
 * @LastEditTime: 2020-05-21 17:08:23
 * @LastEditors: 山淑兰
 */
/**
 * @title 获取当前会议日程信息
 * @date 2019-12-27
 */
export class IGetAPIProgram {
  m: string = "";
  dateid?: number = 0;
  roomid?: number = 0;
  search?: string = "";
}
/**
 * @title 嘉宾日程信息
 * @date 2020-5-21
 */
export class IGetAPIExpertProgram {
  m: string = "";
  exid: number = 0;
}
/**
 * @title 嘉宾日程信息
 * @date 2020-5-21
 */
export class IGetAPIProDateRoom {
  m: string = "";
  dateid?: number = 0;
  roomid?: number = 0;
  search?: string = "";
}

/**
 * @title 嘉宾日程信息
 * @date 2020-5-21
 */
export class IGetAPIExpertProList {
  m: string = "";
  dateid?: number = 0;
  roomid?: number = 0;
  search?: string = "";
}
